import React, { memo } from 'react'
import { useRecoilValue } from 'recoil'
import { servicesData as servicesDataState } from '../store/dataStore'
import { clientsData as clientsDataState, teamData as teamDataState, awardsData as awardsDataState } from '../store/dataStore'
import {
  currentSection as currentSectionState,
  selectedService as selectedServiceState,
  selectedMember as selectedMemberState,
  selectedClient as selectedClientState,
  selectedAward as selectedAwardState,
} from '../store/uiStore'

import Intro from './Intro/Intro'
import About from './About/About'
import Services from './Services/Services'
import ServiceModal from './Services/ServiceModal'
import Team from './Team/Team'
import TeamModal from './Team/TeamModal'
import Clients from './Clients/Clients'
import ClientsModal from './Clients/ClientsModal'
import Awards from './Awards/Awards'
import AwardsModal from './Awards/AwardsModal'
import Contact from './Contact/Contact'

import { Main } from '../styles/globalStyles'

const Sections = () => {
  const currentSection = useRecoilValue(currentSectionState)
  const selectedService = useRecoilValue(selectedServiceState)
  const selectedMember = useRecoilValue(selectedMemberState)
  const selectedClient = useRecoilValue(selectedClientState)
  const servicesData = useRecoilValue(servicesDataState)
  const awardsData = useRecoilValue(awardsDataState)
  const selectedAward = useRecoilValue(selectedAwardState)
  const teamData = useRecoilValue(teamDataState)
  const clientsData = useRecoilValue(clientsDataState)

  const clientsSections = Object.values(clientsData).map((section) => {
    return section.items
  }).flat()

  return (
    <Main>
      <Intro visible={currentSection === 'intro'} />
      <About visible={currentSection === 'quienes-somos'} />
      <Services visible={currentSection === 'servicios'} />
      <Team visible={currentSection === 'equipo'} />
      <Clients visible={currentSection === 'clientes'} />
      <Awards visible={currentSection === 'distinciones'} />
      <Contact visible={currentSection === 'contacto'} />
      {servicesData.services.map((service, index) => (
        <ServiceModal
          key={`modal-service-${index}-main`}
          service={service}
          isActive={selectedService === index}
        />
      ))}
      {clientsSections.map((client) => client.description && (
          <ClientsModal
            key={`modal-client-${client.id}`}
            client={client}
            isActive={selectedClient === client.id}
          />
        ))}
      {teamData.members.map((member, index) => (
        <TeamModal
          key={`modal-member-${member.name}-${index}`}
          member={member}
          isActive={selectedMember === index}
        />
      ))}
      {awardsData.items.map((award) => (
        <AwardsModal
            key={`modal-award-${award.id}`}
            award={award}
            isActive={selectedAward === award.id}
          />
      ))}
    </Main>
  )
}

export default memo(Sections)
